import { Divider, Hidden, HiddenProps } from "@mui/material";

export const HiddenDivider = (props: HiddenProps) => {
  return (
    <Hidden {...props}>
      <Divider />
    </Hidden>
  );
};
